export const CLIENT_VIEW_TYPES = [
  { value: "real_estate", label: "Real Estate" },
  { value: "automotive", label: "Automotive / Vehicle Market" },
  { value: "infrastructure", label: "Infrastructure" },
  { value: "community_intelligence", label: "Community Intelligence" },
  { value: "custom", label: "Custom" },
];

export const CLIENT_VIEW_BASE_PERSPECTIVES = [
  { value: "realEstate", label: "Real Estate" },
  { value: "mobility", label: "Mobility / Vehicle Market" },
  { value: "infrastructure", label: "Infrastructure" },
  { value: "safety", label: "Safety" },
  { value: "weather", label: "Weather" },
  { value: "mixed", label: "Mixed" },
];

export const CLIENT_VIEW_STATUSES = [
  { value: "draft", label: "Draft" },
  { value: "active", label: "Active" },
  { value: "archived", label: "Archived" },
];

export function labelForViewType(value) {
  return CLIENT_VIEW_TYPES.find((item) => item.value === value)?.label || value || "—";
}

export function labelForBasePerspective(value) {
  return (
    CLIENT_VIEW_BASE_PERSPECTIVES.find((item) => item.value === value)?.label ||
    value ||
    "—"
  );
}

export function labelForStatus(value) {
  return CLIENT_VIEW_STATUSES.find((item) => item.value === value)?.label || value || "—";
}

export function statusBadgeTone(status) {
  if (status === "active") {
    return "confirmed";
  }
  if (status === "archived") {
    return "disputed";
  }
  return "pending";
}

export function suggestSlugFromName(name) {
  return String(name || "")
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "");
}

export const EMPTY_CLIENT_VIEW_FORM = {
  name: "",
  slug: "",
  description: "",
  viewType: "real_estate",
  basePerspective: "realEstate",
  status: "draft",
  brandName: "",
  primaryLocation: "",
  defaultCenterLat: "",
  defaultCenterLng: "",
  defaultZoom: "",
  notes: "",
};

export function clientViewToForm(clientView) {
  if (!clientView) {
    return { ...EMPTY_CLIENT_VIEW_FORM };
  }

  return {
    name: clientView.name || "",
    slug: clientView.slug || "",
    description: clientView.description || "",
    viewType: clientView.viewType || "real_estate",
    basePerspective: clientView.basePerspective || "realEstate",
    status: clientView.status || "draft",
    brandName: clientView.brandName || "",
    primaryLocation: clientView.primaryLocation || "",
    defaultCenterLat:
      clientView.defaultCenterLat != null ? String(clientView.defaultCenterLat) : "",
    defaultCenterLng:
      clientView.defaultCenterLng != null ? String(clientView.defaultCenterLng) : "",
    defaultZoom: clientView.defaultZoom != null ? String(clientView.defaultZoom) : "",
    notes: clientView.configJson?.notes || "",
  };
}

export function formToClientViewPayload(form) {
  const configJson = form.notes?.trim() ? { notes: form.notes.trim() } : {};

  return {
    name: form.name.trim(),
    slug: form.slug.trim(),
    description: form.description.trim() || null,
    viewType: form.viewType,
    basePerspective: form.basePerspective || null,
    status: form.status,
    brandName: form.brandName.trim() || null,
    primaryLocation: form.primaryLocation.trim() || null,
    defaultCenterLat: form.defaultCenterLat ? Number(form.defaultCenterLat) : null,
    defaultCenterLng: form.defaultCenterLng ? Number(form.defaultCenterLng) : null,
    defaultZoom: form.defaultZoom ? Number(form.defaultZoom) : null,
    configJson,
  };
}
